<template>
  <vs-tooltip  text="Print" position="top" >
        <vs-button radius   class="mr-2" color="#333f50" type="line" @click="print"  icon="print"></vs-button></vs-tooltip>
</template>

<script>
import moment from 'moment'
import XLSX from 'xlsx' // import xlsx
import html2pdf from 'html2pdf.js'
import jsPDF  from 'jspdf'
import 'jspdf-autotable'
export default {
 props:{
     dataList: Array,
     headerName:String,
     header: Array,
     },
data: () => ({
    nwlist: [],
    headerName: '',
    i: '',
    dataList: [],
    selectFilter:[],
    d:'',
    network: '',
    role: '',
    a: [],
    filter_input: [ {
      alertname : '' ,
      message : '',
      sensorname: '',
      lastdata : '',
      timestamp: '',
      alertstatus: ''
      }
    ],
    filter_list: [],
    primeTable: '',
    finds: [],
    counter: 0,
    dataBody: [],
    dataExport: [],

    }),
 methods: {
     // print
     print() {
      console.log(this.headerName) 
      switch (this.headerName) {
        case "Sensor":
            this.dataList.forEach(element => {
                this.dataBody.push({name: element.name,serial_id: element.serial_id,type: element.type,network: element.network,location: element.location,active: element.active, signal:'100',bat:'100'});
            });
            console.log("Uh oh.");
            break;
        case "Gateway":
            this.dataList.forEach(element => {
                 this.dataBody.push({name: element.name,serial_id: element.serial_id,type: element.type,network: element.network,location: element.location,active: element.active, signal: element.signal});
            });
            console.log("A good day for golf!");
            break;
        case "Alert":
            // var tempData = ""
            // this.dataList.forEach(element => {
            //     element.lastdata.forEach(data => {
            //     Object.keys(data).forEach(key => {
            //         tempData += key+" "+data[key]+" "
            //         })
            //         this.dataBody.push({sensorname: element.sensorname,alertname: element.alertname,lastdata: tempData,alertstatus: element.alertstatus,message: element.message,timestamp: element.timestamp,status: element.alertstatus});
            //     tempData = ""
            //     })
            // });
            console.log("A good day for golf!");
            break;
         case "Network":
            this.dataList.forEach(element => {
                 this.dataBody.push({name: element.name,gateway: element.gateway,sensors: element.sensors});
            });
            console.log(this.dataBody)
            console.log("A good day for golf!");
            break;
         case "Work Order":
            this.dataList.forEach(element => {
                  this.dataBody.push({Work_ID: element.id,name: element.name,asset: element.asset,work_order: element.detail
                             ,creator: "creator"
                             ,start_date: element.plandate,actual_start_date: element.startdate
                             ,end_date: element.duedate,actual_end_date: element.finishtime,time_spend: element.timespent
                             ,percent: element.timespent, status: element.iscomplete});
            });
            console.log(this.dataBody)
            console.log("A good day for golf!");
            break;
        default:
            console.log("Try looking up for a hint.");
        }
      
      console.log(this.dataBody)
      var doc = new jsPDF('p', 'pt');
      doc.setFontSize(11).text(this.headerName+' List', 40, 40); //header
      var newDat = moment().format('MM/DD/YYYY hh:mm:ss'); 
      doc.setFontSize(7).text(505,25,newDat); //timestamp
      var values = this.dataBody.map( (elemento) => Object.values(elemento));
      console.log(values)
      doc.autoTable({theme: 'striped',headStyles: {fillColor: [105, 181, 83] ,textColor: [255, 255, 255]} , styles: { fontSize: 8 ,theme: 'plain'},
          head: [this.header],
          body: values,margin: {top: 50}
      })
      doc.autoPrint();
      doc.output("dataurlnewwindow");
      this.dataBody = []; //Clear dataBody
    },
    }
}
</script>

<style>

</style>